module.exports = __webpack_public_path__ + "images/gadget/map_this.png";